import { useEffect, type ReactNode } from 'react';
import { TraceLockup } from '../../components/TraceLockup.tsx';
import { PreferencesMenu } from '../../components/PreferencesMenu.tsx';
import styles from './authorization.module.css';
import shellStyles from '../../app/AppShell.module.css';
export function PublicLayout({
  title,
  children,
  hideTitleHeading = false,
}: {
  title: string;
  children: ReactNode;
  hideTitleHeading?: boolean;
}) {
  useEffect(() => {
    document.title = `${title} · Traceira`;
  }, [title]);
  return (
    <div className={styles.standalone}>
      <a href="#authorization-main" className={shellStyles.skipLink}>
        Skip to content
      </a>
      <header className={styles.header}>
        <a href="/" className={styles.brand} aria-label="Traceira">
          <TraceLockup variant="tile" height={28} ariaHidden />
        </a>
        <div className={styles.actions}>
          <PreferencesMenu />
        </div>
      </header>
      <main id="authorization-main" className={styles.page}>
        <h1 className={hideTitleHeading ? 'sr-only' : undefined}>{title}</h1>
        {children}
      </main>
    </div>
  );
}
